import React from "react";
import styled from "@emotion/styled";
import CompfestLogo from "components/CompfestLogo";
import HeaderPhoto from "images/DSC04663.jpg";

const Header = styled.div`
  display: flex;
  height: calc(100vh - 76px);
  margin-top: 76px;
  flex-direction: column;
  max-width: 100% !important;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: linear-gradient(rgba(0, 136, 210, 0.7), rgba(0, 136, 210, 0.7)),
    url(${HeaderPhoto}) center 100% / auto calc(100vh - 76px) no-repeat #878988
      fixed;

  @media (max-width: 600px) {
    height: calc(100vh - 50px);
    margin-top: 50px;
    background-size: auto calc(100vh - 50px);

    svg {
      height: 38px;
    }
    p {
      font-size: 14px;
      line-height: 26px;
      margin-bottom: 48px;
    }
  }
`;

const Title = styled.h1`
  font-size: 96px;
  margin: 10px 0;

  @media (max-width: 600px) {
    font-size: 65px;
  }
`;

const Tanggal = styled.p`
  font-size: 30px;
  line-height: 1.4em;
  margin-top: 0;
`;

const Deskripsi = styled.p`
  font-size: 24px;
  max-width: 980px;
  line-height: 38px;
  margin-top: 0;
`;

const Button = styled.button`
  margin-top: 64px;
  padding: 20px 84px;
  color: #000;
  font-size: 22px;
  border-radius: 41px;
  background-color: #fff;

  @media (max-width: 600px) {
    font-size: 16px;
    padding: 12px 54px;
    margin: 0;
  }
`;

export default function HeaderSeminar({ dates, month, desc, onClickExplore }) {
  return (
    <Header>
      <CompfestLogo height="64px" style={{ minHeight: "38px" }} />
      <Title>Seminar</Title>
      <Tanggal>
        {dates}
        <br />
        {month}
      </Tanggal>
      <Deskripsi dangerouslySetInnerHTML={{ __html: desc }} />
      <Button onClick={onClickExplore}>Explore</Button>
    </Header>
  );
}
